import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SuperAdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner"></div>
        <p style={{ marginLeft: '10px' }}>Verifying Super Admin Access...</p>
      </div>
    );
  }
  
  // 1. Check if logged in
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // 2. STRICT CHECK: Role must be 'super_admin'
  // Regular 'admin' users get kicked out here
  if (currentUser.role !== 'super_admin') {
    return <Navigate to="/admin" replace />; // Redirect regular admins to their own dashboard
  }
  
  // 3. Allow Access
  return children;
};

export default SuperAdminRoute;